<template>
  <b-modal
    ref="note-modal"
    title="Ghi chú sản phẩm"
    no-close-on-backdrop
    @ok.prevent="handleSave"
  >
    <b-form-group label="Ghi chú:">
      <b-form-textarea
        v-model="note"
        rows="4"
        max-rows="8"
        placeholder="Nhập ghi chú..."
      />
    </b-form-group>
    <template #modal-footer>
      <b-button variant="secondary" @click="hideModal">Hủy</b-button>
      <b-button variant="primary" :disabled="isSaving" @click="handleSave">
        {{ isSaving ? 'Đang lưu...' : 'Lưu' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { makeToastSuccess } from '@/utils/common';
import { handleError } from '@/utils/common';

export default {
  name: 'InventoryCheckNoteModal',
  props: {
    stockCheckSheetId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      note: '',
      itemId: null,
      isSaving: false,
    };
  },
  methods: {
    showModal(item) {
      this.itemId = item.id;
      this.note = item.note || '';
      this.$refs['note-modal'].show();
    },
    hideModal() {
      this.$refs['note-modal'].hide();
    },
    async handleSave() {
      this.isSaving = true;
      try {
        await ApiService.put(`/v1/stock-check-product/${this.itemId}/note`, {
          note: this.note,
          stockCheckSheetId: this.stockCheckSheetId,
        });
        makeToastSuccess('Cập nhật ghi chú thành công');
        this.$emit('note-saved', { id: this.itemId, note: this.note });
        this.hideModal();
      } catch (err) {
        handleError(err);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
